import { Badge } from '@/components/ui/badge';
import { STATUS_OPTIONS } from '@/lib/appointments-service';

interface AppointmentStatusBadgeProps {
  status: string;
}

const AppointmentStatusBadge = ({ status }: AppointmentStatusBadgeProps) => {
  const statusOption = STATUS_OPTIONS.find(s => s.value === status);
  
  const variants: Record<string, 'default' | 'secondary' | 'destructive' | 'outline'> = {
    paid: 'default',
    confirmed: 'default',
    pending: 'secondary',
    completed: 'outline',
    cancelled: 'destructive',
    failed: 'destructive',
  };

  return (
    <Badge 
      variant={variants[status] || 'outline'}
      className={statusOption?.color}
    >
      {statusOption?.label || status.toUpperCase()}
    </Badge>
  );
};

export default AppointmentStatusBadge;
